<template>
    <div>
        <modal ref="modal" size="md" :has-footer="false" @hidden="close">
            <span slot="title">
                Campaign - {{ campaign.name }}
            </span>
            <div v-if="messages.length">
                <div class="phone-container">
                    <div class="phone-in">
                        <div class="box">
                            <div class="box-message col-12" v-for="step in steps">
                                <img class="mb-2 rounded img-fluid"
                                    :src="messages[step].image"
                                    v-if="messages[step].image" />

                                <img class="mb-2 rounded img-fluid"
                                     :src="campaign.image"
                                     v-else-if="campaign.image" />

                                <div v-html="messages[step].content"></div>
                            </div>
                        </div>
                        <div class="message">
                            <div class="message-input"><span>Write a message...</span></div>
                            <div class="message-button"></div>
                        </div>
                    </div>
                </div>
                <div class="text-center step-controller">
                    <span class="fa fa-arrow-left arrow" data-toggle="tooltip" data-placement="top" title="Previous step"
                        v-if="steps.length > 1"
                        @click="removeStep">
                    </span>
                    <span class="fa fa-arrow-right arrow" data-toggle="tooltip" data-placement="top" title="Next step"
                        v-if="messages.length > steps.length"
                        @click="addStep">
                    </span>
                </div>
            </div>

            <div v-else class="alert alert-warning" role="alert">
                No steps for SMS messages.
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: {
        campaign  : { required: true },
        messages  : {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            steps: [0]
        }
    },

    methods: {
        open () {
            this.$refs.modal.open();
        },

        close() {
            this.$parent.campaign = {};
            this.$parent.messages = [];
        },

        addStep() {
            if (this.steps.length < this.messages.length) {
                this.steps.push(this.steps.length);
            }
        },

        removeStep() {
            this.steps.splice(-1,1);
        }
    },
}
</script>

<style lang="scss" scoped>

/* width */
::-webkit-scrollbar {
    width: 5px;
    margin: 5px;
    transition:0.25s;
}

/* Track */
::-webkit-scrollbar-track {
    background: #fff; 
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #bbb; 
    border-radius:5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #888; 
    border-radius:5px;
    transition:0.5s;
}
.img-fluid {
    max-height: 200px;
    text-align: center;
    display: block;
    margin: 0 auto;
}

.step-controller {
    font-size: 2rem;
    color: #007bff;
}

.phone-container {
    position: relative;
    width: 300px;
    height: 619px;
    margin: auto;
    background: url('/img/phone.svg') center/contain no-repeat;
    .phone-in {
        position: absolute;
        top: 94px;
        left: 29px;
        background-color: white;
        width: 243px;
        height: 432px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        padding: 1em;

        .box {
            flex: 1;
            justify-content: flex-start;
            align-items: flex-end;
            overflow-y: scroll;
            margin: 0.5em 0 0.5em 0.5em;

            .box-message {
                margin-bottom: 20px;
                margin-right:10px;
                margin-left:10px;
                position: relative;
                display: inline-block;
                max-width: 250px;
                max-height: 350px;
                font-size: 0.8rem;
                width: auto;
                padding: 0.5em;
                background-color: #007bff;
                color: white;
                border-radius: 10px;
                word-break: break-all;

                opacity: 0;
                animation: boxappear 0.4s 1s forwards
                    cubic-bezier(0.165, 0.84, 0.44, 1);
                &::before {
                    content: "";
                    position: absolute;
                    left: -8px;
                    bottom: 8px;
                    width: 0;
                    height: 0;
                    border-top: 10px solid transparent;
                    border-bottom: 10px solid transparent;
                    border-right: 10px solid #007bff;
                }
            }
        }

        .message {
            display: flex;
            .message-input {
                font-size: 0.8em;
                padding: 0.5em 1em;
                border-radius: 20px;
                background-color: #f2f2f2;
                color: #888;
                margin-right: 1em;
                display: flex;
                justify-content: center;
                align-items: center;
                flex: 0.8;
                opacity: 0;
                animation: message 1s forwards
                    cubic-bezier(0.165, 0.84, 0.44, 1);
            }
            .message-button {
                background: #007bff url('/img/paper-plane.svg') 45%/45%
                    no-repeat;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                animation: button 1s 2 cubic-bezier(0.165, 0.84, 0.44, 1);
            }
        }
    }
}

.arrow {
    cursor: pointer;
}

@keyframes boxappear {
    from { transform: translateY(10%); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
}
@keyframes message {
    from { flex: 0.8; opacity: 0; }
    to { flex: 1; opacity: 1; }
}

@keyframes button {
    from { transform: scale(0.8); }
    50% { transform: scale(1.1); }
    to { transform: scale(1); }
}
</style>
